'use strict';

angular.module('far.competition').controller('CompetitionReportController', function ($rootScope, $window, $log, competitionReportForm, Competition, CompetitionReport, $scope, FileUploader) {
    var vm = {
        progress: true,
        submitted: false,
        form: {},
        event: {},
        requestController: {},
        fields: competitionReportForm,
        eventType: null,
        eventUserTypes: {},
        event_competition_type: [],
        winners: {},
        btn: {
            accepted: false,
            submitted: false
        },
        init: function (eventId, eventReportEdit) {
            vm.event_competition_type.forEach(function (value) {
                vm.winners[value.id] = {
                    female: {},
                    male: {}
                };

                for (var i = 1; i <= 3; i++) {
                    vm.winners[value.id].female[i] = [{}];
                    vm.winners[value.id].male[i] = [{}];
                }
            });

            if (eventReportEdit) {
                vm.form = CompetitionReport.get(eventId, vm.eventUserTypes, function () {
                    if (vm.form.winners.length) {
                        vm.form.winners.forEach(function (user) {
                            if (user.people_xerox) {
                                var gender = 'female';
                            } else {
                                var gender = 'male';
                            }

                            if (!vm.winners[user.event_competition_type.id][gender][user.place][0].id) {
                                vm.winners[user.event_competition_type.id][gender][user.place] = [];
                            }

                            vm.winners[user.event_competition_type.id][gender][user.place].push(user.user);
                        });
                    }

                    if (vm.form.documents_files.length > 0) {
                        vm.form.documents_files.forEach(function (serverFile) {
                            var newFile = new FileUploader.FileItem(vm.fields.$fields.documentsFiles.uploader, {
                                lastModifiedDate: new Date(),
                                size: 1e6,
                                name: serverFile.original_name
                            });

                            newFile.progress = 100;
                            newFile.isUploaded = true;
                            newFile.isSuccess = true;
                            newFile.serverData = angular.merge({}, serverFile);

                            vm.fields.$fields.documentsFiles.uploader.queue.push(newFile);
                        });
                    }

                    vm.btn.accepted = vm.form.accepted;
                    vm.btn.submitted = vm.form.submitted;

                    vm.progress = false;
                });
            } else {
                vm.form = CompetitionReport.new({
                    event_id: eventId,
                    winners: []
                }, vm.eventUserTypes);

                vm.progress = false;
            }
        },
        sendReport: function () {
            vm.form.submitted = true;
            vm.form.accepted = false;

            $scope.competitionReportForm.$submitted  = true;

            vm.save();
        },
        sendAccepted: function () {
            vm.form.submitted = true;
            vm.form.accepted = true;

            $scope.competitionReportForm.$submitted  = true;

            vm.save();
        },
        save: function () {
            if ((vm.form.submitted || vm.form.accepted) && (vm.progress || $scope.competitionReportForm.$invalid)) {
                return;
            }

            vm.form.documents_files = vm.documents_files;

            vm.form.event = vm.requestController.getEventData();

            vm.form.winners = [];

            for (var type in vm.winners) {
                for (var gender in vm.winners[type]) {
                    for (var place in vm.winners[type][gender]) {
                        for (var i in vm.winners[type][gender][place]) {
                            if (vm.winners[type][gender][place][i].id != undefined) {
                                vm.form.winners.push({
                                    user: vm.winners[type][gender][place][i].id,
                                    event_competition_type: type,
                                    place: place,
                                    people_xerox: (gender == 'female')
                                });
                            }
                        }
                    }
                }
            }

            var users = [];

            for (var user_key in vm.form.users) {
                if (vm.form.users[ user_key ].user) {
                    users.push(vm.form.users[ user_key ]);
                }
            }

            vm.form.users = users;

            console.log(vm.form.users.length);

            vm.form.save()
                .then(function (response) {
                    $window.location.href = Routing.generate('event_view', {id: response.data.id});
                }, function (response) {

                });
        }
    };

    vm.fields.$fields.safety.uiSelectOptions.onSelect = function (item, model, options) {
        vm.form.updateUser(options.index, item);
    };

    vm.fields.$fields.judge.uiSelectOptions.onSelect = function (item, model, options) {
        vm.form.updateUser(options.index, item);
    };

    vm.fields.$fields.winner.uiSelectOptions.onSelect = function (item, model, options) {
        if (typeof item == 'undefined') {
            delete vm.winners[options.type][options.gender][options.place][options.index];
        } else {
            vm.winners[options.type][options.gender][options.place][options.index] = item;
        }
    };

    return vm;
});
